import { linkCls } from './atom.link.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

const ToolLink = ({
  tool,
  onClick
}) => {
  const handleClick = evt => {
    evt.preventDefault();
    onClick();
    window.open(window.gProxy.forwardTo(tool.url), "_blank", tool.specs);
  };
  return /*#__PURE__*/jsxs("a", {
    className: linkCls,
    href: tool.url,
    onClick: handleClick,
    children: [/*#__PURE__*/jsx("b", {
      children: tool.title
    }), tool.subtitle]
  });
};

export { ToolLink };
//# sourceMappingURL=atom.link.js.map
